import { View } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { FinancialServicesListAnimated } from "@repo/core/components/layout/FinancialServicesListAnimated";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { SelectFinancialServiceController } from "@repo/core/screens/ProposalEffectiveFlows/Credit/SelectFinancialService/controller";

const SelectFinancialService = () => {
  const {
    financialServices,
    selectedFinancialServiceId,
    handleSelectFinancialService,
    handleOnSubmitForm,
    handleGoBack,
    isMobile
  } = SelectFinancialServiceController();
  return (
    <Scaffolds.Root
      minHeight="$100vh"
      title="Serviços Financeiros"
      onBackPress={handleGoBack}
      showBackButtonOnWeb
    >
      <Scaffolds.Form
        showHeader={false}
        centerFormContent={false}
        footerContent={
          <View
            w="$full"
            gap="$4"
            flexDirection={!isMobile ? "row-reverse" : "column"}
            pt={isMobile ? "$4" : "$12"}
            px="$4"
            pb="$4"
            justifyContent="flex-end"
          >
            <Button
              size="xl"
              isDisabled={!selectedFinancialServiceId}
              action={selectedFinancialServiceId ? "primary" : "secondary"}
              text="Salvar"
              w="$full"
              onPress={handleOnSubmitForm}
            />
          </View>
        }
      >
        <View flex={1}>
          <FinancialServicesListAnimated
            financialServices={financialServices}
            onSelectFinancialService={handleSelectFinancialService}
            selectedFinancialService={selectedFinancialServiceId || ""}
          />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};
export default SelectFinancialService;
